import React from 'react';
import { useModulesContext } from '../services/providers/ModulesProvider';
import ExternalPageLoader from '../utils/ExternalPageLoader';

const FilteredModules = ({ componentName, props = {} }) => {
  const modules = useModulesContext();

  if (modules.length === 0) return <div></div>;

  const filteredModules = modules
    .filter((module) => {
      if (Array.isArray(module.componentPosition)) {
        return module.componentPosition.includes(componentName);
      }
      return module.componentPosition === componentName;
    })
    .sort((a, b) => a.componentOrder - b.componentOrder);

  return (
    <>
      {filteredModules.map((moduleData) => (
        <ExternalPageLoader
          key={moduleData.id}
          moduleUrl={moduleData.moduleUrl}
          containerName={moduleData.containerName}
          componentPath={moduleData.componentPath}
          props={props}
        />
      ))}
    </>
  );
};

export default FilteredModules;
